import React from 'react';
import { observer } from 'mobx-react';
import { Map, GoogleApiWrapper} from 'google-maps-react';
import { map } from '../helpers/constants';

import CustomMarker from './CustomMarker';

const KEY = 'AIzaSyAZk1OQVp3sApAt7PHetwWPGMrqrgnx2Bk';

class MapComponent extends React.Component {
    render() {
        const { google, onClick, onMapClick, markerData, likedPoints } = this.props;
        const { center, zoom } = map;

        return (
            <Map
                google={google}
                initialCenter={center}
                zoom={zoom}
                onClick={onMapClick}
                containerStyle={styles.container}
                streetViewControl={false}
                fullscreenControl={false}
            >
                {
                    markerData.map((point, i) => {
                        return (
                            <CustomMarker 
                                {...this.props}
                                point={point}
                                key={i}
                                onClick={onClick}
                                google={google}
                                likedPoints={likedPoints}
                            />
                        )
                    })
                }
            </Map>
        )
    }
}

const styles = {
    container: {
        width: '100%', 
        height: 'calc(100% - 90px)'
    }
}

export default GoogleApiWrapper({
    apiKey: (KEY)
})(observer(MapComponent))
